import { useQuery } from "@tanstack/vue-query";
import { defineStore, storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useIsOrderCommercialStore } from "./is-commercial.store";
import { queries } from "@erp/shared/queries";
export const useOrderStore = defineStore("order", () => {
    const isCommercialStore = useIsOrderCommercialStore();
    const { isCommercial } = storeToRefs(isCommercialStore);
    const userInput = ref(null);
    const confirmQueryOptions = computed(() => {
        return { ...queries.order.confirm(isCommercial.value, userInput.value ?? undefined),
            enabled: computed(() => !!userInput.value),
        };
    });
    const { data, isFetching, refetch } = useQuery(confirmQueryOptions);
    return {
        userInput,
        data,
        isFetching,
        refetch,
    };
});
